import {
    FETCH_FILE_FOR_THUMBNAIL,
    FETCH_FILE_FOR_THUMBNAIL_START,
    FETCH_FILE_FOR_THUMBNAIL_SUCCESS,
    FETCH_FILE_FOR_THUMBNAIL_ERROR,
    ADD_THUMBNAIL_LINK,
    CLEAR_THUMBNAIL_LINKS,
} from './constants'


const fetchFileForThumbnail = () => ({ type: FETCH_FILE_FOR_THUMBNAIL })
const fetchFileForThumbnailStart = () => ({ type: FETCH_FILE_FOR_THUMBNAIL_START })
const fetchFileForThumbnailSuccess = () => ({ type: FETCH_FILE_FOR_THUMBNAIL_SUCCESS })
const fetchFileForThumbnailError = (error) => ({ type: FETCH_FILE_FOR_THUMBNAIL_ERROR, error })
const addThumbnailLink = (info, url) => ({ type: ADD_THUMBNAIL_LINK, info, url })
const clearThumbnailLinks = () => ({ type : CLEAR_THUMBNAIL_LINKS })

export {
    fetchFileForThumbnail,
    fetchFileForThumbnailStart,
    fetchFileForThumbnailSuccess,
    fetchFileForThumbnailError,
    addThumbnailLink,
    clearThumbnailLinks
}